import { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { verifyAdminAccess } from '../services/api';

export const AdminCheck = () => {
  const { user } = useAuth();

  useEffect(() => {
    const checkAdmin = async () => {
      try {
        console.log('Current user state:', user);
        const result = await verifyAdminAccess();
        console.log('Admin verification result:', result);
      } catch (error) {
        console.error('Admin check error:', error);
      }
    };

    checkAdmin();
  }, [user]);

  return null;
}; 